import { post } from '@/services/awsAmplify'

export const createChannel = async (companionId: UUID) =>
  await post({
    path: '/messaging-channel',
    params: { companionId },
  })
